import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  getCall,
  postCall,
  deleteCall,
  getById,
  BASE_URL,
} from "../../utils/api";
import axios from "axios";
import toast from "react-hot-toast";

const initialState = {
  data: [],
  outletDetail: null,
  error: "",
  status: "idle",
  isUpdateStatus: "idle",
};

export const getOutlet = createAsyncThunk(
  "Outlet/get",
  async ({ query = "", page = 1, per_page = 50 }) => {
    try {
      const response = await getCall(
        `/admin/v1/outlets?query=${query}&page=${page}&per_page=${per_page}`,
        false
      );
      return await response;
    } catch (error) {
      return Promise?.reject(error);
    }
  }
);

export const getOutletById = createAsyncThunk("Outlet/getById", async (id) => {
  try {
    const response = await getById("/admin/v1/show_outlet", id, false);
    return await response;
  } catch (error) {
    return Promise?.reject(error);
  }
});

export const addOutlet = createAsyncThunk("Outlet/add", async (data) => {
  try {
    const response = await postCall("/admin/v1/add_outlet", data);
    return await response;
  } catch (error) {
    return Promise?.reject(error);
  }
});

export const getOutletRefById = createAsyncThunk("Outlet/getRefById", async (id) => {
  try {
    return await await getById("/admin/v1/show_outlet_ref", id, false);
  } catch (error) {
    return Promise?.reject(error);
  }
});

export const addOutletFromRef = createAsyncThunk("Outlet/addFromRef", async ({id, formData}) => {
  try {
    const response = await postCall(`/admin/v1/outlet_ref/${id}/create_outlet`, formData);
    return await response;
  } catch (error) {
    return Promise?.reject(error);
  }
});

export const updateOutlet = createAsyncThunk(
  "Outlet/update",
  async ({ id, formData }, { rejectWithValue }) => {
    const token = JSON.parse(localStorage.getItem("token"));
    try {
      const response = await axios.post(
        `${BASE_URL}/admin/v1/update_outlet/${id}`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      toast.success(response.data.message || "Outlet updated successfully!");
      return response.data;
    } catch (error) {
      toast.error("Unable to update data. Please try again later.");
      return rejectWithValue(error.response.data);
    }
  }
);

export const multipleDeleteOutlet = createAsyncThunk(
  "Outlet/delete",
  async (id) => {
    try {
      await deleteCall(`/admin/v1/delete_outlet?outlet_id=${id}`);
      return await id;
    } catch (error) {
      return Promise?.reject(error);
    }
  }
);
const OutletSlice = createSlice({
  name: "outlet",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getOutlet.pending, (state) => {
        state.status = "loading";
      })
      .addCase(getOutlet.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.data = action.payload;
      })
      .addCase(getOutlet.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message || "An unknown error occurred";
      })
      .addCase(getOutletById.pending, (state) => {
        state.status = "loading";
      })
      .addCase(getOutletById.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message || "An unknown error occurred";
      })
      .addCase(getOutletById.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.outletDetail = action.payload;
      })
      .addCase(addOutlet.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(addOutlet.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.data.data.push(action.payload);
      })
      .addCase(addOutlet.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message || "An unknown error occurred";
      })
      .addCase(updateOutlet.pending, (state) => {
        state.isUpdateStatus = "loading";
        state.error = null;
      })
      .addCase(updateOutlet.fulfilled, (state, action) => {
        state.isUpdateStatus = "succeeded";
        const index = state.data.data.findIndex(
          (outlet) => outlet.id === action.payload.data.id
        );
        if (index >= 0) {
          state.data.data[index] = action.payload.data;
        }
      })
      .addCase(updateOutlet.rejected, (state, action) => {
        state.isUpdateStatus = "failed";
        state.error = action.error.message || "An unknown error occurred";
      })
      .addCase(multipleDeleteOutlet.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(multipleDeleteOutlet.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.data = state.data.data.filter(
          (Outlet) => Outlet.id !== action.payload
        );
      })
      .addCase(multipleDeleteOutlet.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message || "An unknown error occurred";
      })
      .addCase(getOutletRefById.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(getOutletRefById.fulfilled, (state) => {
        state.status = "succeeded";
      })
      .addCase(getOutletRefById.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message || "An unknown error occurred";
      })
      .addCase(addOutletFromRef.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(addOutletFromRef.fulfilled, (state) => {
        state.status = "succeeded";
      })
      .addCase(addOutletFromRef.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message || "An unknown error occurred";
      })
  },
});

export default OutletSlice.reducer;
